export const SEARCH_ROUTES = {
  categories: '/search',
  testSeries: '/search/test-series',
  quizPyp: '/search/quiz-pyp',
  questions: '/search/questions',
  lectures: '/search/lectures',
  shortNotes: '/search/short-notes',
  exams: '/search/exams',
  blogs: '/search/blogs',
  questionDetail: '/search/questions/detail',
  noteDetail: '/search/short-notes/detail',
  articleDetail: '/search/blogs/detail',
  lectureDetail: '/search/lectures/detail',
  seriesQuizzes: '/search/series/quizzes',
  demoLecture: '/search/lectures/demo',
};
